export const CompareListsModal: string = 'CompareListsModal';
